// extracted by mini-css-extract-plugin
export var dateLabel = "_2w-0";
export var dateLabelError = "_2w-1";
export var fullWidth = "_2w-2";
export var smaller = "_2w-3";